import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class ChatLogService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token: any, task: any): Observable<any> {  
    let json = JSON.stringify(task);
    // json = encodeURIComponent(json);
    const params = new HttpParams()
      .set("json", json)
      .set("authorization", token);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/chatlog/new?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  getChat(token: any, id: any, task: any): Observable<any> {
    let json = JSON.stringify(task);
    // json = encodeURIComponent(json);
    const params = new HttpParams()
      .set("json", json)
      .set("authorization", token);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/chatlog/listbyfather/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  update(token: any, task: any, id: any): Observable<any> {
    let json = JSON.stringify(task);
    // json = encodeURIComponent(json);
    const params = new HttpParams()
      .set("json", json)
      .set("authorization", token);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/chatlog/edit/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  remove(token: any, id: any): Observable<any> {
    const params = new HttpParams().set("authorization", token);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/chatlog/remove/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  edit(token, task, chat_id): Observable<any> {
    let json = JSON.stringify(task);
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/chatlog/edit/${chat_id}`, params, {
      headers: headers,
    });
  }
  viewMessage(token, id, task): Observable<any> {
    let json = JSON.stringify(task);
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/chatlog/viewmessage/${id}`, params, {
      headers: headers,
    });
  }

  createchatforpayment(token: any, task: any): Observable<any> {  
    let json = JSON.stringify(task);
    const params = new HttpParams()
      .set("json", json)
      .set("authorization", token);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });


    return this._http.post<any>(
      `${this.url}/chatlog/newPaymentChat`,
      params.toString(),
      { headers }
    );
  }
  viewMessagepayment(token, id, task): Observable<any> {
    let json = JSON.stringify(task);
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/chatlog/listPaymentChat/${id}`, params, {
      headers: headers,
    });
  }
  getcommentPayment(token, task): Observable<any> {
    let json = JSON.stringify(task);
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/chatlog/getPaymentStepChat`, params, {
      headers: headers,
    });
  }
}
